<template>
  <c-busy v-if="loadStatus === $config.status.LOADING" />

  <c-grid v-else-if="loadStatus === $config.status.SUCCESS">

    <c-grid-item :span="6">
      <c-card>
        <c-title tag="h2">Persönliche Daten</c-title>

        <c-title tag="h3">Name</c-title>
        <p>{{ title }} {{ firstName }} {{ lastName }}</p>

        <c-title tag="h3">Geschlecht</c-title>
        <p>{{ gender }}</p>

        <c-title tag="h3">Geburtsdatum und -ort</c-title>
        <p>{{ dateOfBirth | formatDate }} in {{ countryOfBirth }}</p>
      </c-card>
    </c-grid-item>

    <c-grid-item :span="6">
      <c-card>
        <c-title tag="h2">Kontakt</c-title>

        <c-title tag="h3">Adresse</c-title>
        <address>
          {{ street }} {{ houseNumber }}<br>
          {{ postalCode }} {{ city }}<br>
          {{ state }}
        </address>

        <c-title tag="h3">E-Mail-Adresse</c-title>
        <p>{{ email }}</p>

        <c-title tag="h3">Telefonnummer</c-title>
        <p>{{ phone }}</p>
      </c-card>
    </c-grid-item>

    <c-grid-item :span="6">
      <c-card>
        <c-title tag="h2">Foto</c-title>
        <img
          v-if="image"
          :alt="`Foto von ${title} ${firstName} ${lastName}.`"
          :src="$config.appUrl + image"
        >
        <p v-else>Kein Foto hinterlegt.</p>
      </c-card>
    </c-grid-item>

    <c-grid-item
      v-if="$store.getters['user/regionalGroups'][regionalGroup]"
      :span="6"
    >
      <c-card>
        <c-title tag="h2">Regionalgruppe</c-title>
        <p>{{ $store.getters['user/regionalGroups'][regionalGroup].name }}</p>
      </c-card>
    </c-grid-item>

    <c-grid-item :span="12">
      <c-card>
        <p>Sollte sich Ihre Mailadresse ändern, schreiben Sie uns bitte an <a href="mailto:info@claussen-simon-stiftung.de">info@claussen-simon-stiftung.de</a>.</p>
        <c-button-router-link :to="{ name: 'dashboard-personal-data' }">Persönliche Daten bearbeiten</c-button-router-link>
      </c-card>
    </c-grid-item>

    <c-grid-item :span="12">
      <c-card>
        <p>Ihre Eingaben im Bewerbungsformular werden zwischengespeichert. Sie können sich also später erneut anmelden, wenn Sie Ihre Bewerbung vervollständigen oder bearbeiten möchten. Nach Einreichen der Bewerbung ist keine Änderung mehr möglich.</p>
      </c-card>
    </c-grid-item>
  </c-grid>

</template>

<script>
import CCard from '@/components/CCard'
import CBusy from '@/components/CBusy'
import CGrid from '@/components/CGrid'
import CGridItem from '@/components/CGridItem'
import CTitle from '@/components/CTitle'
import CButtonRouterLink from '@/components/CButtonRouterLink'

import formatDate from '@/functions/formatDate'
import handleRequestError from '@/functions/handleRequestError'

export default {
  name: 'CProfileDisplay',

  components: {
    CCard,
    CBusy,
    CGrid,
    CGridItem,
    CTitle,
    CButtonRouterLink
  },

  filters: {
    formatDate
  },

  data () {
    return {
      loadStatus: this.$config.status.IDLE,
      gender: '',
      title: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      countryOfBirth: '',
      email: '',
      street: '',
      houseNumber: '',
      postalCode: '',
      state: '',
      city: '',
      phone: '',
      image: '',
      regionalGroup: ''
    }
  },

  created () {
    this.loadStatus = this.$config.status.LOADING

    this.$api.get('user/profile/')
      .then(response => {
        this.gender = response.data.gender
        this.title = response.data.title
        this.firstName = response.data.first_name
        this.lastName = response.data.last_name
        this.email = response.data.email
        this.dateOfBirth = new Date(response.data.birthday)
        this.countryOfBirth = response.data.birthcountry
        this.street = response.data.street
        this.houseNumber = response.data.street_nr
        this.postalCode = response.data.zip
        this.state = response.data.state
        this.city = response.data.city
        this.phone = response.data.phone
        this.regionalGroup = response.data.regional_group
        this.image = response.data.image

        this.loadStatus = this.$config.status.SUCCESS
      })
      .catch(error => {
        handleRequestError({
          error,
          fallback: 'Ihre persönlichen Daten können zurzeit leider nicht geladen werden. Bitte versuchen Sie es später erneut.'
        })

        this.loadStatus = this.$config.status.ERROR
      })
  }
}
</script>
